// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2WzZ_","vLegacy":"SelectSecondary_vLegacy__3MRGh","error":"SelectSecondary_error__3zGrE","disabled":"SelectSecondary_disabled__1gFZ6"};